import $ from 'jquery'

export default class MyPjax {
	constructor(){
		this.$document = $(document);
		this.$window = $(window);
		this.$body = $("body");
		this.$site = $(".site");
		this.$loading = $(".sp_loading");
		this.spMaxSize = 414;
		this.$scrollingElement = 'scrollingElement' in document ? $(document.scrollingElement) : navigator.userAgent.indexOf('WebKit') != -1 ? $(document.body) : $(document.documentElement);
		this.pjaxSetup();
		this.init();
	}

	pjaxSetup() {
		$.pjax({
	        area : '#main, .top_visual' , //再描画させるエリア
	        // area : '#main, .top_visual, .site-free_space-wrapper' , //再描画させるエリア ページごとに看板の表示を変える場合
	        link : 'a:not([href^="#"]):not([target])', // pjaxを発動させるlinkにつけるclass
	        ajax : { timeout: 2500 }, // ajaxの通信のタイムアウト時間
	        wait : 0, // 押してから発動するまでの時間
	        cache: {
	        		click: false,
	        		submit: false,
	        		popstate: false
	        		},  // キャッシュの設定
	        load: { head: 'base, meta, link', css: false, script: false },  // 再描画するエリアを選べる、インラインスクリプトを動作させるかどうか
	        callback : function() { //一番最後に呼ばれる


			},
	        callbacks:{ // callbackを設定出来る
	        	before : function() {

			    },
	            update : {
	                content: {
	                	before: (event, setting, dstContent, srcContent) => {　//一番目に呼ばれる
		                    this.resetBodyClass(dstContent);

		                },
	                    after : ( event, setting, srcContent, dstContent ) => { //二番目に呼ばれる
	                    	this.$document.trigger("pjaxResetEvent");

	                    }
	                }
	            }
	        }
		});

		this.$document.on("pjax:fetch", this.onPjaxFetch.bind(this)); //データ取得前
		this.$document.on("pjaxResetEvent", this.onPjaxReset.bind(this)); //データアップデート後
	}

	init() {

		const topVisualUrl = $(".top_visual>div").css("background-image").match(/https?:\/\/[-_.!~*'()a-zA-Z0-9;\/?:@&=+$,%#]+[a-z]/g);
		const image = new Image();
		image.src = topVisualUrl;

		if(image.complete) {
			this.start();
		}else {
			const $img = $(image)

			$img.on( 'load', () => {
				$img.off('load')
				this.start()
			})
		}
	}

	start() {
		if(this.$window.width() >  this.spMaxSize ){

			$(".site-sprite_animation").css({
				"animation": "sprite_animation 0.5s steps(8, end) forwards",
			});
		}else if(this.$window.width() <=  this.spMaxSize ){
			this.$loading.removeClass("show");
        	this.$site.fadeIn();
        }
	}

	resetBodyClass(dstContent){
        const bodyClass = $(dstContent).filter('#main').data('bodyattr');
        this.$body.removeClass().addClass(bodyClass);
    }

	goToScrollTop() {
		this.$scrollingElement.animate({
			scrollTop: 0
		} ,300, 'easeOutExpo');
	}

	onPjaxFetch(event) {
		this.goToScrollTop();
		if(this.$window.width() >  this.spMaxSize ){
			$(".site-sprite_animation").css({
				"animation": "sprite_animation_alternate 0.5s steps(8, end) forwards",
			});
		}else if(this.$window.width() <=  this.spMaxSize ){
			this.$loading.addClass("show");
			this.$site.fadeOut();
		}
	}

	onPjaxReset(event) {
		this.init();
	}

}
